var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-tab",class:{
    'c-tab--is-active': _vm.value == _vm.id
  }},[_c('a',{attrs:{"href":_vm.href},on:{"click":function($event){$event.preventDefault();return _vm.onTabClick()}}},[_vm._v(" "+_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }